import axios from 'axios';

export default {
  selectors: (params = {}) => axios.get('expense-classes/selectors', { params }),
  store: (payload = {}) => axios.post('expense-classes', payload),
};
